import styled from 'styled-components'

export const PEQComponent = styled.div`
  margin-top: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin: 0 15px;
  }

  /* define spacers */
  .ml {
    margin-left: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin-left: 30px;
    }
  }

  .peq-bar-graph {
    width: 240px;
  }

  .accordion-rating .ml .peq-bar-graph {
    max-width: 100%;
    width: 100%;
  }

  .single-peq-label {
    display: block;
    margin-bottom: 10px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      display: inline-block;
      margin-bottom: 0;
      margin-right: 20px;
    }
  }

  .toggle-link {
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 15px;
  }

  .peq-footer-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 20px;
    padding-top: 10px;

    .toggle-link {
      text-align: right;
    }

    .peq-hint {
      color: ${ (props) => props.theme.colors['icon-grau0'] };
      flex-grow: 1;
      margin-bottom: 15px;
    }
  }

  .separator {
    width: 100%;
    height: 1px;
    background-color: ${ (props) => props.theme.colors['icon-grau1'] };
    margin-bottom: 20px;
  }

  .additional-info-container {
    margin-bottom: 30px;
  }

  .additional-info-copy {
    margin-top: 20px;
  }
`

export const SinglePEQ = styled.div`
  margin-bottom: 15px;
  margin-right: 26px;
  display: block;

  .average-value {
    font-weight: bold;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    justify-content: space-between;
    display: flex;
    align-items: flex-end;

    .bar-graph-average {
      // calc percentage to pixels to set average indicator to total pixels
      // to make sure all indicators have the same width (also at non-retina displays)
      // see https://bugs.onedev.aok.de/browse/MGMPMNAV-1019
      left: ${ (props) => props.ratingAverage }%;
    }
  }
`
